'use client';

import { Callout, Icon } from 'daskapital-ds';

import { BlocksProps } from '@/lib/wordpress/_types/blocksStyle';
import classNames from 'classnames';
import displayBlock from '@/lib/wordpress/blocks/displayBlock';

export type IBlockCallout = {
	attrs: {
		variant?: 'info' | 'success' | 'warning' | 'tip';
		title?: string;
		icon?: string;
		anchor?: string;
		className?: string;
		animation?: string;
	};
	innerBlocks?: BlocksProps[];
};

export default function BlockCallout({ attrs, innerBlocks }: IBlockCallout) {
	const { variant, title, icon, anchor, className, animation } = attrs || {};

	return (
		<Callout
			id={anchor || undefined}
			variant={variant || 'info'}
			title={title}
			icon={icon ? <Icon icon={icon} /> : undefined}
			className={classNames(className, animation && `elements_animated ${animation}`)}>
			{innerBlocks?.map((block, index) => displayBlock(block, index))}
		</Callout>
	);
}
